export default "__VITE_ASSET__M_nKpjrS__"